export default {
  percentage: 'PERCENTAGE',
  number: 'NUMBER',
};
